import { Input } from "@frui.ts/bootstrap";
import BankCodeType from "entities/bankCodeType";
import React from "react";
import Col from "react-bootstrap/Col";
import AuInput from "controls/finance/auInput";
import BikInput from "controls/finance/bikInput";
import CcInput from "controls/finance/ccInput";
import FwInput from "controls/finance/fwInput";
import SwiftInput from "controls/finance/swiftInput";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { translateGeneral } from "../../utils/localizations";

export interface BankCodeInputGroupProps {
  target: {
    bank?: string;
  };
  codeType?: BankCodeType;
  disabled?: boolean;
  md?: number;
}

function BankCodeInputGroup(props: BankCodeInputGroupProps) {
  const { codeType, target, disabled, md } = props;
  let bankCodeInput = null;
  const label: string = translateGeneral(`finance.${codeType ?? "bankCode"}`);

  if (codeType === BankCodeType.Bic) {
    bankCodeInput = <SwiftInput disabled={disabled} />;
  } else if (codeType === BankCodeType.Bik) {
    bankCodeInput = <BikInput disabled={disabled} />;
  } else if (codeType === BankCodeType.Au) {
    bankCodeInput = <AuInput disabled={disabled} />;
  } else if (codeType === BankCodeType.Fw) {
    bankCodeInput = <FwInput disabled={disabled} />;
  } else if (codeType === BankCodeType.Cc) {
    bankCodeInput = <CcInput disabled={disabled} />;
  } else {
    bankCodeInput = <Input disabled={disabled} />;
  }

  return (
    <FormGroup as={Col} md={md ?? 6} target={target} property="bank">
      <FormLabel>{label}</FormLabel>
      {bankCodeInput}
    </FormGroup>
  );
}

export default BankCodeInputGroup;
